@if ((mediaRecord$ | async)?.hasPreview()) {
  <video #player class="video-js vjs-fluid vjs-big-play-centered"></video>
} @else {
  <sh-media-placeholder [spinning]="spinning$ | async" class="placeholder" [message]="placeholderMessage" [showMessage]="true"></sh-media-placeholder>
}

